class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

    // Close button in the header
    const closeButtons = this.querySelectorAll('.drawer__close');
    closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });

    // Mobile back button
    const backButton = this.querySelector('.drawer__back-button');
    if (backButton) {
      backButton.addEventListener('click', this.close.bind(this));
    }

    // Debug logging
    console.log('CartDrawer initialized with close buttons:',
      closeButtons.length > 0 ? `${closeButtons.length} close buttons found` : 'No close buttons found',
      backButton ? 'Mobile back button found' : 'No mobile back button'
    );
  }

  open() {
    // Add active class to make drawer visible
    this.classList.add('active');

    // Add class to prevent body scrolling
    document.body.classList.add('overflow-hidden');

    // Focus trap for accessibility
    this.activeElement = document.activeElement;

    // Ensure the drawer is visible
    const drawerElement = this.querySelector('.cart-drawer');
    if (drawerElement) {
      drawerElement.setAttribute('aria-hidden', 'false');
    }

    // Update cart button state
    const cartButton = document.getElementById('mobile-cart-icon-bubble');
    if (cartButton) {
      cartButton.setAttribute('aria-expanded', 'true');
    }

    console.log('Cart drawer opened');
  }

  close() {
    // Remove active class to hide drawer
    this.classList.remove('active');

    // Allow body scrolling again
    document.body.classList.remove('overflow-hidden');

    // Return focus to the element that opened the drawer
    if (this.activeElement) {
      this.activeElement.focus();
    }

    // Hide the drawer for screen readers
    const drawerElement = this.querySelector('.cart-drawer');
    if (drawerElement) {
      drawerElement.setAttribute('aria-hidden', 'true');
    }

    // Update cart button state
    const cartButton = document.getElementById('mobile-cart-icon-bubble');
    if (cartButton) {
      cartButton.setAttribute('aria-expanded', 'false');
    }

    console.log('Cart drawer closed');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Add diagnostic logging
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    console.log('Cart drawer element found on page');

    // Log all close buttons
    const closeButtons = cartDrawer.querySelectorAll('.drawer__close, .drawer__back-button');
    console.log(`Found ${closeButtons.length} close buttons in cart drawer`);

    closeButtons.forEach((button, index) => {
      console.log(`Close button ${index + 1}:`, button);
    });

    // Cart icon now links directly to cart page
    console.log('Cart icon now links directly to cart page - no drawer event added');
  } else {
    console.log('No cart drawer element found on page');
  }
});